















































































































import { Component, Vue, Prop } from 'vue-property-decorator';
import Info from './Service/Info';
import applyForm from './form';
import panelGroup from '../components/panel-group.vue';
import $i18n from '@/modules/FPKG-20000-Util/lang'; // 取得多國文本

import {
  getLastMonthEndDate,
  getLastMonthStartDate,
  getMonthEndDate,
  getMonthStartDate,
  getLastWeekEndDate,
  getLastWeekStartDate,
  getWeekEndDate,
  getWeekStartDate,
  yesterday,
  today,
} from '@/modules/FPKG-20000-Util/prototypes/TimeLib';

@Component({
  components: {
    panelGroup,
  },
})
export default class modify extends Vue {
  private searchForm: any = {};

  private applyForm: Object = applyForm;

  private breadcrumb: Array<object> = [];

  private tableData: Array<Object> = [];

  private dialogAdvSearch: boolean = false;

  private toolbarHeight: Number = 50;
  private security_code: string = '';

  private advSearch() {
    const query: any = { ...this.$route.query, ...this.searchForm };
    query.t = Date.now();
    query.p12_cig_security_code = this.security_code;
    this.$router.push({ query: this.searchForm });
    this.getInfo(this.searchForm);
    this.dialogAdvSearch = false;
  }

  public breadSubstring(label: any) {
    const that = this;
    const text = label.substring(0, 4);
    if (text === 'NODE') {
      return this.$t(`Permission.${label}`);
    }
    return label;
  }

  public breadcrumbList() {
    const tempData: Array<object> = [];
    const urlList = JSON.parse(localStorage.getItem('Node') || '{}');
    const routeUrl = this.$route.meta.url;
    const node = urlList.filter(
      (item: any) => item.p4_node_route === routeUrl,
    )[0];
    tempData.push({
      label: node.p4_node_code,
      href: node.p4_node_route,
      icon: node.icon,
    });
    this.actions(tempData, urlList, node.p4_node_pid);
    tempData.reverse();
    this.breadcrumb = tempData;
  }

  /**
   * 將麵包屑用遞迴方式實做出來
   */

  private actions(data: Array<object>, urlList: Array<object>, pid?: number) {
    const that = this;
    if (pid !== null) {
      const node: any = urlList.find((item: any) => item.p4_node_id === pid);
      data.push({
        label: node.p4_node_code,
        href: node.p4_node_route,
        icon: node.icon,
      });
      that.actions(data, urlList, node.p4_node_pid);
    }
  }

  /** 昨日 */
  private yesterday() {
    const s1 = yesterday();
    this.$set(this.searchForm, 'start_time', `${s1} 00:00:00`);
    this.$set(this.searchForm, 'end_time', `${s1} 23:59:59`);
    this.advSearch();
  }

  /** 今日 */
  private today() {
    const s1 = today();
    this.$set(this.searchForm, 'start_time', `${s1} 00:00:00`);
    this.$set(this.searchForm, 'end_time', `${s1} 23:59:59`);
    this.advSearch();
  }

  /** 上週 */
  private BeforeWeek() {
    const s1 = getLastWeekStartDate();
    const s2 = getLastWeekEndDate();
    this.$set(this.searchForm, 'start_time', `${s1} 00:00:00`);
    this.$set(this.searchForm, 'end_time', `${s2} 23:59:59`);
    this.advSearch();
  }

  /** 本週 */
  private Week() {
    const s1 = getWeekStartDate();
    const s2 = getWeekEndDate();
    this.$set(this.searchForm, 'start_time', `${s1} 00:00:00`);
    this.$set(this.searchForm, 'end_time', `${s2} 23:59:59`);
    this.advSearch();
  }

  /** 上月 */
  private BeforeMoon() {
    const s1 = getLastMonthStartDate();
    const s2 = getLastMonthEndDate();
    this.$set(this.searchForm, 'start_time', `${s1} 00:00:00`);
    this.$set(this.searchForm, 'end_time', `${s2} 23:59:59`);
    this.advSearch();
  }

  /** 本月 */
  private Moon() {
    const s1 = getMonthStartDate();
    const s2 = getMonthEndDate();
    this.$set(this.searchForm, 'start_time', `${s1} 00:00:00`);
    this.$set(this.searchForm, 'end_time', `${s2} 23:59:59`);
    this.advSearch();
  }

  /**
   * getInfo 取得資料
   */
  public async getInfo(params?: any) {
    /**
     * 二次密碼
     */
    this.$prompt('', `${$i18n.t('Transaction.securityCode')}`, {
      confirmButtonText: `${$i18n.t('Util.enter')}`,
      cancelButtonText: `${$i18n.t('Util.cancel')}`,
    })
      .then(async (value: any) => {
        this.security_code = value.value;
        params.p12_cig_security_code = this.security_code;
        const getter = (await new Info(params).get()) as any;
        this.tableData = getter;
        this.security_code = '';
      })
      .catch((e) => {});
  }

  private mounted() {
    this.Moon();

    // const { query } = this.$route;
    // this.searchForm = query;
    // this.getInfo({});

    this.$bus.$on('yesterday', () => {
      this.yesterday();
    });
    this.$bus.$on('today', () => {
      this.today();
    });
    this.$bus.$on('BeforeWeek', () => {
      this.BeforeWeek();
    });
    this.$bus.$on('Week', () => {
      this.Week();
    });
    this.$bus.$on('BeforeMoon', () => {
      this.BeforeMoon();
    });
    this.$bus.$on('Moon', () => {
      this.Moon();
    });
    this.$bus.$on('customTime', () => {
      this.dialogAdvSearch = true;
    });
  }

  private created() {
    this.breadcrumbList();
  }
}
